import React from 'react';
import { Pagination } from '@components/common';

export const CollectionPagination = ({
    enablePagination,
    externalModels,
    currentPage,
    totalPages,
    onPageChange,
    itemsPerPage,
    onItemsPerPageChange,
    itemsPerPageOptions,
    totalItems,
    hasNext,
    hasPrevious,
    order_by
}) => {
    // Don't show pagination if disabled or using external models
    if (!enablePagination || externalModels) return null;

    return (
        <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            order_by={order_by}
            onPageChange={onPageChange}
            itemsPerPage={itemsPerPage}
            onItemsPerPageChange={onItemsPerPageChange}
            itemsPerPageOptions={itemsPerPageOptions}
            totalItems={totalItems}
            showItemsPerPage={true}
            hasNext={hasNext}
            hasPrevious={hasPrevious}
        />
    );
};

export default CollectionPagination;
